import asyncComponent from '../common/utils/async-component.js';

const Billing = asyncComponent(async () => import('./components/billing/index.js'));

export default {
  '/billing': {
    components: { main: Billing }
  }
};
